import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  WorkflowActionDialogData,
  WorkflowActionDialogItem,
} from '@shared/models/workflow-action-dialog.model';
import { ZDialogComponent } from '../z-dialog/z-dialog.component';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-workflow-action-dialog',
    templateUrl: './workflow-action-dialog.component.html',
    styleUrls: ['./workflow-action-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ZDialogComponent,
        MatIcon,
        TranslatePipe,
    ],
})
export class WorkflowActionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<WorkflowActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WorkflowActionDialogData,
  ) {}

  handleAction(actionItem: WorkflowActionDialogItem): void {
    if (actionItem.disabled) {
      return;
    }

    if (actionItem.closeOnClick) {
      this.dialogRef.close(actionItem.id);
      setTimeout(() => actionItem.action?.(), 0);
      return;
    }

    actionItem.action?.();
  }

  trackByActionId(_: number, actionItem: WorkflowActionDialogItem): string {
    return actionItem.id;
  }
}